<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="piii"></a>The Sacking of Fallujah</h1>
<h1 class="bk1">A People’s History</h1>
<p class="bkau">R<span class="sm">OSS</span> C<span class="sm">APUTI</span></p>
<p class="bkau">R<span class="sm">ICHARD</span> H<span class="sm">IL</span></p>
<p class="bkau">D<span class="sm">ONNA</span> M<span class="sm">ULHEARN</span></p>
<p class="bkpub">University of Massachusetts Press</p>
<p class="bkpub1"><i>Amherst and Boston</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// uma-CAPUTI-0004.vue?59617f34